import { Location as NgLocation } from '@angular/common';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { HTTP_STATUS_CODES } from '@bbraun/cortex/shared';
import { OAuthService } from 'angular-oauth2-oidc';
import { catchError, tap } from 'rxjs';

import { ROUTES } from '../definitions/constants/routes.constants';
import { HelperService } from '../utils/helper/helper.service';

export const unauthorizedErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const oAuthService = inject(OAuthService);
  const ngLocation = inject(NgLocation);

  return next(request).pipe(
    tap(response => response),
    catchError((error: HttpErrorResponse) => {
      if (error?.status === HTTP_STATUS_CODES.UNAUTHORIZED) {
        oAuthService.logOut();
      }
      if (error?.status === HTTP_STATUS_CODES.FORBIDDEN) {
        if (error.error.message?.includes('Offline customer functionality is not active for customer')) {
          ngLocation.go(ROUTES.REPLENISHMENT);
          HelperService.reloadPage();
        }
        if (error.error.message?.includes('Reason is not provided')) {
          ngLocation.go(ROUTES.REPLENISHMENT);
          HelperService.reloadPage();
        }
      }
      throw error;
    })
  );
};
